// ShopDashboard.js
import React from 'react';
import ShopNotifications from './ShopNotifications';

const ShopDashboard = () => {
  return (
    <div className="shop-dashboard">
      <h1>Welcome to Your Shop Dashboard</h1>
      <ShopNotifications />
    </div>
  );
};

export default ShopDashboard;
